import React from 'react';

import { SearchIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { InputProps } from '@vlabs/uikit/components/controls/input/Input';
import { useTranslation } from 'react-i18next';

function QuickSearchInput({
  onChangeValue = undefined,
  value = undefined,
  ...props
}: InputProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Control.Input
      {...props}
      data-testid="quickSearchInput"
      icon={<SearchIcon />}
      onChangeValue={onChangeValue}
      placeholder={t('card-list-page:quick search input label') as unknown as string}
      value={value}
    />
  );
}

export { QuickSearchInput };
